import { render, staticRenderFns } from "./DashboardDown.vue?vue&type=template&id=176b6d2b"
import script from "./DashboardDown.vue?vue&type=script&lang=js"
export * from "./DashboardDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports